import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { CountrySectorHelperTexts } from '@features/watchlists/models/country-sector-texts.model';

@Component({
  selector: 'app-watchlist-country-sector-helper',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatCardModule, MatGridListModule],
  templateUrl: './country-sector-helper.component.html',
  styleUrl: './country-sector-helper.component.scss',
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WatchlistCountrySectorHelperComponent {
  helperTexts = input.required<CountrySectorHelperTexts>();
}
